import { Input } from 'common/InputForm'
import NotFound from 'common/NotFound'
import React, { useState } from 'react'
import { TbTruckDelivery } from 'react-icons/tb'
import { updateDeliveryStatusApi } from 'services/masterApi'

const DeliveryFees = ({ manageDeliveryList, setManageDeliveryList = () => { }, onHide, getsManageDeliverySlots = () => { } }) => {

  const [loadingId, setLoadingId] = useState(null);

  // const handleValueChange = (newValue, id) => {
  //   const validValue = newValue.replace(/[^0-9]/g, '');
  //   const updatedList = manageDeliveryList.map(item =>
  //     item._id === id ? { ...item, value: validValue } : item
  //   );
  //   setManageDeliveryList(updatedList);
  // };
  const handleValueChange = (newValue, id, field) => {
    const validValue = newValue.replace(/[^0-9]/g, ''); // allow only numbers
    const updatedList = manageDeliveryList.map(item =>
      item._id === id ? { ...item, [field]: validValue } : item
    );
    setManageDeliveryList(updatedList);
  };

  return (
    <div className="d-flex flex-column mt-4">
      <h5 className="mb-3 fw-semibold text-dark">Delivery Fees</h5>

        {manageDeliveryList && manageDeliveryList.length > 0 ? (
          manageDeliveryList?.map((data, index) => {
            return (
              <React.Fragment key={index}>
               
                 <div className="d-flex align-items-center gap-3 mt-4">
                <div className="form_field">
                  <Input
                    label='From (KM)'
                    type="text"
                    name="from"
                    placeholder='From'
                    value={data?.from || ""}
                    onChange={(e) => handleValueChange(e.target.value, data?._id, "from")}
                    maxLength={9}
                  />
                </div>
                <div className="form_field">
                  <Input
                    label='To (KM)'
                    type="text"
                    // className="w-25"
                    name="to"
                    placeholder='To'
                    value={data?.to || ""}
                    onChange={(e) => handleValueChange(e.target.value, data?._id, "to")}
                    maxLength={9}
                  />
                </div>
                <div className="form_field">
                  <Input
                    label='Amount'
                    type="text"
                    // className="w-25"
                    name="value"
                    placeholder='Amount'
                    value={data?.value || ""}
                    onChange={(e) => handleValueChange(e.target.value, data?._id, "value")}
                    maxLength={9}
                  />
                </div>
                <button
                  type="button"
                  disabled={loadingId === data?._id}
                  className="button"
                  onClick={() => updateDeliveryStatusApi(
                    data?._id,
                    null, // status,
                    data?.value,
                    null,//buttonLader
                    null,//modalClose
                    null,//getsManageDeliverySlots,
                    null,//List,
                    null, //setList
                    setLoadingId,//setLoadingId
                    data?.from,
                    data?.to,
                    "DELIVERYFEES"
                  )}
                >
                  {loadingId === data?._id ? "Loading..." : "Change value"}
                </button>
                </div>
              </React.Fragment>
            );
          })
        ) : (
          <table className="table custom_table">
            <tbody>
              <NotFound
                cols={3}
                msg={"Delivery Fees Not Found"}
                onHide={onHide}
                icon={<TbTruckDelivery />}
              />
            </tbody>
          </table>
        )}
    </div>

  )
}

export default DeliveryFees